import type { FormEvent } from "react";

import { REQUIRED_MESSAGE, useDialogForm } from "@/ds";
import { EDIT_PERMISSION_FORM_ID } from "./edit-permission-dialog.constants";
import type {
  EditPermissionDialogProps,
  EditPermissionDialogViewModel,
  EditPermissionValues,
} from "./types-edit-permission-dialog";

function validate({ nome, descricao }: EditPermissionValues) {
  return {
    ...(nome.trim() ? {} : { nome: REQUIRED_MESSAGE }),
    ...(descricao.trim() ? {} : { descricao: REQUIRED_MESSAGE }),
  };
}

/**
 * Formulário de edição (HU 902): nome e descrição obrigatórios, validados em tela antes de qualquer requisição (MS de
 * campo obrigatório); o código nunca entra no envio (RN01) e o nome segue editável até a decisão do PO (12/08).
 */
export function useEditPermissionDialog({
  permission,
  onSubmit,
  onCancel,
}: EditPermissionDialogProps): EditPermissionDialogViewModel {
  const form = useDialogForm<EditPermissionValues>({
    initial: { nome: permission.nome, descricao: permission.descricao },
    validate,
    onSubmit: (values) =>
      onSubmit({ nome: values.nome.trim(), descricao: values.descricao.trim() }),
  });

  return {
    formId: EDIT_PERMISSION_FORM_ID,
    codigo: permission.codigo,
    nome: {
      value: form.values.nome,
      error: form.errors.nome ?? null,
      digitar: (texto) => form.setValue("nome", texto),
    },
    descricao: {
      value: form.values.descricao,
      error: form.errors.descricao ?? null,
      digitar: (texto) => form.setValue("descricao", texto),
    },
    isSubmitting: form.isSubmitting,
    enviar: (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      void form.submit();
    },
    cancelar: onCancel,
  };
}
